import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from 'vuetify';
import colors from 'vuetify/es5/util/colors'
import App from './App';
import router from './router';
import store from './store';
import Link from './components/Common/Link.vue';
import 'vuetify/dist/vuetify.min.css';

Vue.config.productionTip = false;
Vue.use(Vuetify, {
  theme: {
    primary: colors.indigo.lighten2
  }
})
Vue.use(Vuex);
Vue.use(Vuetify);

Vue.config.productionTip = false;

Vue.component('Link', Link);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
